export default function ($http) {
    return function (vehicleId, keeperId, model) {
        return $http.post(`api/vehicles/${vehicleId}/confirmation/${keeperId}/keeperConfirmationLetter`, model);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/createLetter/createKeeperConfirmationLetter.js